<template>
  <div class="mt-search-content">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: "MtSearchContent",
};
</script>


// WEBPACK FOOTER //
// src/components/Mt/MtSearchContent/index.vue